import React, {Suspense} from 'react';
import {IconButton, Typography} from "@mui/material";
import menus from "./menus";
import JumboVerticalNavbar from "@jumbo/components/JumboVerticalNavbar/JumboVerticalNavbar";
import {DrawerHeader} from "@jumbo/components/JumboLayout/style";
import JumboScrollbar from "@jumbo/components/JumboScrollbar";
import useJumboLayoutSidebar from "@jumbo/hooks/useJumboLayoutSidebar";
import useJumboSidebarTheme from "@jumbo/hooks/useJumboSidebarTheme";
import {SIDEBAR_STYLES, SIDEBAR_VIEWS} from "@jumbo/utils/constants/layout";
import Logo from "../../../../shared/Logo";
import MenuOpenIcon from '@mui/icons-material/MenuOpen';
import Zoom from "@mui/material/Zoom";
import Div from "@jumbo/shared/Div";
import SidebarSkeleton from "./SidebarSkeleton";
import { useState } from 'react';
import { useEffect } from 'react';
import useJumboAuth from '@jumbo/hooks/useJumboAuth';
import jwtAuthAxios from 'app/services/auth/jwtAuth';
import axios from 'axios';
import { BACKEND_APP_URL } from 'app/utils/constants/paths';

const Sidebar = () => {
    const jumboco = useJumboAuth();
    const[menutree,setMenutree]= useState(jumboco.menuObject)
    // useEffect(async()=>{
    //     jumboco.setAuthOptions({type:'set-menudata',payload:[]})
    // },[])    
    useEffect(async()=>{
        // console.log(jumboco.authToken , jumboco.authUser , jumboco.menuObject.length);
        // console.log(jumboco.authToken && jumboco.authUser && jumboco.menuObject.length == 0);
    if(jumboco.authToken && jumboco.authUser && jumboco.menuObject.length == 0) {
        // await menus().then(async data =>{jumboco.setAuthOptions({type:'set-menudata',payload:data})})
        // const frtchCurrencyRate = useCallback(()=>{
            // axios.get(BACKEND_APP_URL+'master/currencyRate').then(async (res)=>{
            //     await jumboco.setAuthOptions({type:'set-curr',payload:{cd:'¥',Rate:res.data.data}})
            //     // setCurrencyRate(res.data.data)
            // })
        // },[])
    }
    },[])
    useEffect(async()=>{
        // console.log(menutree);
    },[menutree])
    useEffect(async()=>{
        // console.log(jumboco.menuObject);
        setMenutree(jumboco.menuObject?.Menu || [])
    },[jumboco.menuObject])
    return (
        <React.Fragment>
            <SidebarHeader/>
            <JumboScrollbar
                autoHide
                autoHideDuration={200}
                autoHideTimeout={500}
            >
                <Suspense
                    fallback={
                        <Div
                            sx={{
                                display: 'flex',
                                minWidth: 0,
                                alignItems: 'center',
                                alignContent: 'center',
                                px: 3
                            }}
                        >
                            <SidebarSkeleton/>
                        </Div>
                    }
                >
                    {menutree.length == 0 ?<SidebarSkeleton/>:<JumboVerticalNavbar translate items={menutree}/>}
                </Suspense>
            </JumboScrollbar>
        </React.Fragment>
    );
};

const SidebarHeader = () => {
    const {sidebarOptions, setSidebarOptions} = useJumboLayoutSidebar();
    const {sidebarTheme} = useJumboSidebarTheme();

    const isMiniAndClosed = React.useMemo(() => {
        return sidebarOptions?.view === SIDEBAR_VIEWS.MINI && !sidebarOptions?.open;
    }, [sidebarOptions.view, sidebarOptions.open]);


    return (
        <React.Fragment>
            {
                sidebarOptions?.style !== SIDEBAR_STYLES.CLIPPED_UNDER_HEADER &&
                <DrawerHeader>
                    <div style={{display: 'flex',alignItems: 'center'}}><div style={{maxWidth: '100%'}}><Logo mini={isMiniAndClosed} mode={sidebarTheme.type}/></div>
                    {/* <Typography variant={"h3"} sx={{p:2,pl:1}}>Blossom</Typography> */}
                    </div>
                    {
                        sidebarOptions?.view !== SIDEBAR_VIEWS.MINI &&
                        <Zoom in={sidebarOptions?.open}>
                            <IconButton
                                edge="start"
                                color="inherit"
                                aria-label="open drawer"
                                sx={{ml: 0, mr: -1.5}}
                                onClick={() => setSidebarOptions({open: false})}
                            >
                                <MenuOpenIcon/>
                            </IconButton>
                        </Zoom>
                    }
                </DrawerHeader>
            }
        </React.Fragment>
    )
};

export default Sidebar;
